class Blog {
	constructor( block ) {
		this.$block = $( block );
		this.$resourceWrapper = this.$block.find( "[data-post-ref]" );
		this.$loadMore = this.$block.find( "[data-load-more-posts]" );
		this.$loadMoreText = this.$loadMore.find( ".button-text" );
		this.$mobileSelect = this.$block.find( "[data-blog-content-mobile-select]" );
		this.$categorySelect = this.$block.find( "[data-blog-content-category-select]" );
		this.$currentSelectText = this.$categorySelect.find( ".select-text" );
		this.$tabs = this.$block.find( "[data-category-item]" );
		this.$preloader = this.$block.find( "[data-blog-content-preloader]" );
		this.$message = this.$block.find( "[data-blog-content-message]" );
		this.$blogUrl = this.$block.data( "hm-blog-url" );
		this.boundHandleClickOutsideSelect = this.handleClickOutsideSelect.bind( this );

		this.messageState = {
			noPosts: this.$message.text(),
			error: "Sorry, something went wrong."
		};

		this.ajaxMorePosts = undefined;
		this.env = {
			page: this.$block.data( "hm-next-page" ),
			category: this.$block.data( "hm-category" ),
			postsPerPage: this.$block.data( "hm-posts-per-page" ),
			action: "load_more_posts"
		};

		this.$loadMore.off( "click" ).on( "click", this.loadMore.bind( this ) );
		this.$tabs.off( "click" ).on( "click", this.handleTabClick.bind( this ) );
		this.$categorySelect.off( "click" ).on( "click", this.handleSelectClick.bind( this ) );

		this.setActiveTab( this.env.category );
	}

	updateUrl() {
		const $activeTab = this.$tabs.filter( ".active" );
		const categorySlug = $activeTab.data( "category-slug" ) || "";
		const pagePart = this.env.page > 1 ? `page/${this.env.page}/` : "";
		const categoryPart = categorySlug ? `?category=${categorySlug}` : "";

		const newUrl = `${this.$blogUrl}${pagePart}${categoryPart}`;
		window.history.pushState( {}, "", newUrl );
	}

	setActiveTab( categoryId ) {
		this.$tabs.removeClass( "active" );
		const $currentCategory = this.$tabs.filter( `[data-category-id="${categoryId}"]` );
		$currentCategory.addClass( "active" );
		this.$currentSelectText.text( $currentCategory.text() );
	}

	loaderState() {
		const self = this;
		let loadMoreText = "";

		return {
			load() {
				self.$message.fadeOut( 0 );

				if ( self.env.page === 1 ) {
					self.$resourceWrapper.fadeOut( 150 );
					self.$loadMore.fadeOut( 150 );
					self.$preloader.fadeIn( 150 );
				} else {
					loadMoreText = self.$loadMoreText.text();
					self.$loadMore.attr( "disabled", true );
					self.$loadMoreText.text( "Loading..." );
				}
			},
			success( resources, resetContent = false ) {

				if ( resetContent ) {
					self.$resourceWrapper.html( resources );
					self.$resourceWrapper.fadeIn( 150 );
					self.$loadMore.fadeIn( 150 );
					self.$preloader.fadeOut( 150 );
				} else {
					self.$resourceWrapper.append( resources );
					self.$loadMore.removeAttr( "disabled" );
					self.$loadMoreText.text( loadMoreText );
				}
			},
			error() {
				self.$preloader.fadeOut( 150 );
				self.$message.text( self.messageState.error );
				self.$message.fadeIn( 150 );
				self.$loadMore.fadeOut( 150 );
				self.$loadMore.removeAttr( "disabled" );
				self.$loadMoreText.text( loadMoreText );
			}
		};
	}

	handleTabClick( event ) {
		event.preventDefault();
		const isCurrent = $( event.currentTarget ).hasClass( "active" );

		if ( this.ajaxMorePosts || isCurrent ) {
			return;
		}

		const $target = $( event.currentTarget );
		const categoryId = $target.data( "category-id" );
		this.env.category = categoryId;
		this.env.page = 1;

		this.setActiveTab( categoryId );
		this.updateUrl();
		this.loadCategoryPosts();
		this.closeSelect();
	}

	openSelect() {
		this.$mobileSelect.slideDown( 150 );
		this.$mobileSelect.addClass( "opened" );

		setTimeout( () => {
			$( document ).on( "click", this.boundHandleClickOutsideSelect );
		}, 0 );
	}

	closeSelect() {
		this.$mobileSelect.slideUp( 0 );
		this.$mobileSelect.removeClass( "opened" );

		$( document ).off( "click", this.boundHandleClickOutsideSelect );
	}

	handleSelectClick() {
		if ( this.$mobileSelect.hasClass( "opened" ) ) {
			this.closeSelect();
		} else {
			this.openSelect();
		}
	}

	handleClickOutsideSelect( event ) {
		const clickedOutsideMobileSelect = !this.$mobileSelect.is( event.target ) && this.$mobileSelect.has( event.target ).length === 0;
		const clickedOutsideCategorySelect = !this.$categorySelect.is( event.target ) && this.$categorySelect.has( event.target ).length === 0;

		if ( clickedOutsideMobileSelect && clickedOutsideCategorySelect ) {
			this.closeSelect();
		}
	}

	handleResize() {
		if ( window.matchMedia( "(min-width: 1280px)" ).matches ) {
			if ( this.$mobileSelect.hasClass( "opened" ) ) {
				this.closeSelect();
			}
		}
	}

	loadCategoryPosts() {
		this.ajaxMorePosts = this.ajax( true );
	}

	loadMore( event ) {
		event.preventDefault();
		this.ajaxMorePosts = this.ajax();
		this.updateUrl();

		window.addEventListener( "popstate", ( event ) => {
			event.preventDefault();
			window.location.href = document.location;
		} );
	}

	ajax( reset = false ) {
		if ( this.ajaxMorePosts ) {
			return;
		}

		const loader = this.loaderState();

		return $.ajax( {
			url: "/wp-admin/admin-ajax.php",
			data: this.env,
			type: "POST",
			dataType: "json",
			beforeSend: () => {
				loader.load();
			},
			success: data => {
				if ( !data ) {
					this.$message.text( self.messageState.noPosts );
					return this.$loadMore.hide();
				}

				if ( reset ) {
					loader.success( data.resources, true );
				} else {
					loader.success( data.resources );
				}

				if ( data.isLast ) {
					this.$loadMore.hide();
				} else {
					this.env.page += 1;
					this.$loadMore.show();
				}
			},
			error: ( jqXHR, textStatus, errorThrown ) => {
				loader.error();

				console.warn( jqXHR + " :: " + textStatus + " :: " + errorThrown );
			},
			complete: () => {
				this.ajaxMorePosts = undefined;
			}
		} );
	}
}

export default Blog;
